import React, { useState } from 'react';
import { TextField, Button, Grid, Paper, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';


const AddForm = ({fetchData,handleClose,handleFetchSuccess,handleFetchFailure}) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
  name : ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => { 

    const userDetails = JSON.parse(localStorage.getItem('token'));
    let token = userDetails ? userDetails.result.token : null;
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_BASE_URL}/campaigns`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });
      if (response.status === 401) {
        alert('Session Expired, Please login again');
        localStorage.removeItem('token');
        navigate('/login');
      }
      handleClose();
      if (!response.ok) {
        handleFetchFailure();
        throw new Error('Network response was not ok');
      }
      handleFetchSuccess();
      handleClose();
        fetchData();
    } catch (error) {
      console.error('Error submitting form data:', error);
      handleFetchFailure(); 
      handleClose();
    }
  };  

  
  return (
    <Grid container justifyContent="center" className=''>
      <Grid item>
        <Paper elevation={0} style={{ padding: '5px',  maxHeight: '70vh', overflowY: 'auto' }} >
            <form onSubmit={handleSubmit} className='flex flex-col justify-center'>
              <div className=' gap-2'>
                <div>
              <TextField
                fullWidth
                margin="normal"
                label="Campaign Name"
                id="name"
                name="name"
                value={data.name}
                onChange={handleChange}
                required
              />
              
              <div className='flex gap-3 items-center justify-start'> 
    </div>

    <div className='flex gap-3 items-center justify-start'> 
    </div>
              </div>
              </div>
              <Button variant="contained" sx={{borderRadius:'20px',backgroundColor: 'var(--color-button)', '&:hover': {
                backgroundColor: 'var(--color-button-hover)', 
            },}} type="submit">
                Submit
              </Button>
            </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AddForm;
